module.exports = __webpack_public_path__ + "static/heavy_ugl3-0d0ab59371a9e34a9e0842d81cb50a75.jpg";